<template>
  <div class="component-body">
    <el-tag v-for="(tag,index) in tags" :key="tag.name" closable :type="tag.type"
            :class="index !== 0 ? 'margin-left-15' : ''">
      {{ tag.name }}
    </el-tag>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      tags: [
        { name: '标签一', type: '' },
        { name: '标签二', type: 'success' },
        { name: '标签三', type: 'info' },
        { name: '标签四', type: 'warning' },
        { name: '标签五', type: 'danger' }
      ]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/16/Tag/index.vue